export class EventsList extends Map {
  /**
   *
   * @param {string} key
   * @param {InteractiveEvent} event
   */

  /**
   * @param {string} key
   * @param {InteractiveEvent} event
   * @return {boolean}
   */
  set(key, event) {
    if (super.has(key)) {
      /* every reconnect and re-subscribe cause repeat delivery all create command,
       * caused too often, may just skip it due to binding.id absolutely uniq */
      return false;
    }
    super.set(key, event);
    return true;
  }

  /**
   * Iterate all stored event and dispatch special "delete" case,
   * then clean itself.
   */
  clear() {
    super.forEach((event) => {
      event.dispatch.leaveObject();
    });
    super.clear();
  }

  /*
  It is too dangerous to delete event from eventsList, just mark as "deleted"
  */
  delete(key) {
    const event = super.get(key);
    if (event) {
      event.dispatch.delete();
      return true;
    }

    return false;
  }
}
